import { privateAxios } from 'services/api/privateAxios';

export const getCustomerAddresses = () =>
  privateAxios({
    method: 'get',
    url: '/address',
  });
